import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["fileInput", "iframe"];

  download() {
    this.iframeTarget.contentWindow.postMessage(
      { type: "scratch-gui-download", filename: "project.sb3" },
      window.location.origin,
    );
  }

  openFileChooser() {
    this.fileInputTarget.value = "";
    this.fileInputTarget.click();
  }

  upload() {
    const files = this.fileInputTarget.files;
    if (files) {
      this.iframeTarget.contentWindow.postMessage(
        { type: "scratch-gui-upload", file: files[0] },
        window.location.origin,
      );
    }
  }

  remix() {
    this.iframeTarget.contentWindow.postMessage(
      { type: "scratch-gui-remix" },
      window.location.origin,
    );
  }

  save() {
    this.iframeTarget.contentWindow.postMessage(
      { type: "scratch-gui-save" },
      window.location.origin,
    );
  }
}
